import {
  getCoreRowModel,
  useReactTable,
  type ColumnDef,
  type OnChangeFn,
  type Row,
  type RowData,
  type RowSelectionState,
  type Table,
} from "@tanstack/react-table";

interface TableMeta<TData extends RowData> {
  addRow: (value?: TData) => void;
  // updateRow: (row: Row<TData>, value: TData) => void;
  deleteRow: (row: Row<TData>) => void;
}

export interface EditableTable<TData> extends Table<TData> {
  meta?: TableMeta<TData>;
}

export type EditableColumnDef<TData extends RowData> = ColumnDef<TData> & {
  meta: {
    editable: boolean;
  };
};

interface UseEditableTableProps<TData> {
  data: TData[];
  columns: EditableColumnDef<TData>[];
  onCreate: () => void;
  // onUpdate: (entry: TData) => void;
  onDelete: (row: Row<TData>) => void;
  // onCellClick: (rowIdx: number, cellId: string, cellValue: unknown) => void;
  rowSelection?: RowSelectionState;
  onRowSelectionChange?: OnChangeFn<RowSelectionState>;
}

export const useEditableTable = <TData>({
  data,
  columns,
  onCreate,
  // onUpdate,
  onDelete,
  // onCellClick,
  rowSelection,
  onRowSelectionChange,
}: UseEditableTableProps<TData>): EditableTable<TData> => {
  const table = useReactTable<TData>({
    data,
    columns,
    state: {
      ...(rowSelection ? { rowSelection } : {}),
    },
    enableRowSelection: true,
    onRowSelectionChange: onRowSelectionChange,
    getCoreRowModel: getCoreRowModel(),
    meta: {
      addRow() {
        onCreate();
      },
      deleteRow(row) {
        // if (rowSelection && onRowSelectionChange) {
        //   const newSelections: Record<string, boolean> = {};
        //   for (const [key] of Object.entries(rowSelection)) {
        //     const keyNum = parseInt(key, 10);
        //     if (keyNum < rowIndex) {
        //       newSelections[key] = true;
        //     } else if (keyNum > rowIndex) {
        //       newSelections[(keyNum - 1).toString()] = true;
        //     }
        //   }
        //   onRowSelectionChange(newSelections);
        // }
        onDelete(row);
      },
      // updateRow(_row: Row<TData>, newData: TData) {
      //   onUpdate(newData);
      // },
    },
  });

  return table;
};
